var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0287 2.26111C11.6328 1.91296 12.3672 1.91296 12.9713 2.26111L19.9713 6.29559C20.0542 6.3434 20.1331 6.3968 20.2074 6.45521L16.8439 8.3938C16.717 8.23591 16.5633 8.0993 16.3873 7.99188L8.95502 3.45628L11.0287 2.26111Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46091 4.31744L4.0287 6.29561C3.94576 6.34342 3.86694 6.39682 3.79257 6.45523L12 11.1856L15.4263 9.21086L7.61972 4.44685C7.55999 4.4104 7.50691 4.36669 7.46091 4.31744Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.8045L12.75 12.5335V22C12.8253 21.9684 12.8992 21.9318 12.9713 21.8903L19.9713 17.8558C20.6062 17.4898 21 16.7956 21 16.042V8.10935C21 8.00215 20.992 7.89614 20.9765 7.79211L17.25 9.93991V14.1506C17.25 14.5803 16.9142 14.9286 16.5 14.9286C16.0858 14.9286 15.75 14.5803 15.75 14.1506V10.8045Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.5335V22C11.1747 21.9684 11.1008 21.9318 11.0287 21.8903L4.02871 17.8558C3.39378 17.4898 3 16.7956 3 16.042V8.10935C3 8.00215 3.00797 7.89614 3.02347 7.79211L11.25 12.5335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox4);
export default __webpack_public_path__ + "static/media/box-4.c715abb93649350946b25ad79f78a79e.svg";
export { ForwardRef as ReactComponent };